import EditCriteria from "../../features/CRUD/crudCriteriaList/Components/EditCriteria/EditCriteria"

const EditCriteriaPage  = () => {
  return (
    <div>
      <EditCriteria />
    </div>
  )
}

export default EditCriteriaPage
